module.exports = __webpack_public_path__ + "images/13f370cfebb532d11f0985e655a356cc5.svg";